export function getFio(user?: {
  first_name: string
  last_name: string
  middle_name?: string
}) {
  if (!user) return ''

  return `${user.last_name} ${user.first_name} ${user.middle_name || ''}`
}

export function formatHours(str: string) {
  try {
    const [hours, minutes] = str?.split(':')
    return `${hours}:${minutes}`
  } catch (error) {
    return null
  }
}
